import Vue from 'vue'

const authorization = {
  state: {
    authorizeObj: localStorage.getItem('smba-authorizeObj') && JSON.parse(localStorage.getItem('smba-authorizeObj')) ? JSON.parse(localStorage.getItem('smba-authorizeObj')) : null,
    currentPhone: ''
  },
  mutations: {
    applyAuthorize: function (state, authorizeObj) {
      localStorage.setItem('smba-authorizeObj', JSON.stringify(authorizeObj))
      state.authorizeObj = authorizeObj
    },
    changeCurrentPhone: function (state, currentPhone) {
      state.currentPhone = currentPhone
    },
    clearAuthorize: function (state) {
      state.authorizeObj = null
      localStorage.removeItem('smba-authorizeObj')
      Vue.$cookies.remove('authorization')
    }
  },
  actions: {
    // 注销用户授权信息
    logoutRequest: function (context) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$ajax({
          url: '/enrolling/center/logout',
          method: 'post'
        }).then(response => {
          context.commit('clearAuthorize')
          resolve()
        }, () => {
          reject(new Error('用户注销请求发送失败'))
        })
      })
    }
  }
}

export default authorization



// WEBPACK FOOTER //
// ./src/store/modules/authorization.js